function roundNumber(n: number, precision: number): number {
  if (!Number.isInteger(precision)) {
    throw new TypeError('Expected precision to be an integer');
  }

  const factor = 10 ** precision;
  // Number.EPSILON ensure more accurate rounding of decimals like 1.255 which would normally incorrectly get rounded to 1.25
  // Number.EPSILON also allows for rounding negatives away from 0, consistent with other tools like BQ
  const tempNumber = n * factor * (1 + Number.EPSILON);
  const roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
}

export default roundNumber;
